@if (isKitchenStaff) {
  <app-kitchen-orders></app-kitchen-orders>
} @else {
  <app-all-orders></app-all-orders>
}
